// extracted by mini-css-extract-plugin
export default {"card":"card_card__7WVYK","image":"card_image__V6uxX","full":"card_full__zDXCC","content":"card_content__10S6h","title":"card_title__Si1MX"};